import { TaskData } from '../../../models';
import { ChangeEvent, FormEvent, useState } from 'react';
import { postFeedback } from '../../../utils/api-calls/postFeedback';
import { useActivityData } from '../UseActivityData';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type FeedbackModalProps = {
  taskData: TaskData;
  closeFeedbackModal: (goShare: boolean, feedback?: string) => void;
};

export function FeedbackModal({
  closeFeedbackModal,
  taskData,
}: FeedbackModalProps) {
  const [t] = useTranslation(['chatroom', 'common']);
  const { room } = useActivityData();
  const [feedback, setFeedback] = useState<string>('');

  const { memberId } = useParams();
  const handleFeedbackChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFeedback(() => event.target.value);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    postFeedback(room!.id, memberId!, taskData.id, feedback).then(() => {
      closeFeedbackModal(true, feedback);
    });
  };

  const handleCloseClick = () => {
    closeFeedbackModal(false);
  };

  const createAnswerBlock = () => {
    const { question, answer, type } = taskData;
    if (type === 'image') {
      return (
        <div className="h-[40vh] w-full">
          <img
            alt="pic"
            src={answer}
            className="m-auto object-contain w-full h-full"
          />
        </div>
      );
    }

    return (
      <div className="w-full flex flex-col p-3 gap-3 bg-gray-300">
        <span>Q: {question}</span>
        <span className="font-semibold text-xl">A: {answer}</span>
      </div>
    );
  };

  if (!taskData) {
    return <></>;
  }

  return (
    <div className="bg-white flex flex-col p-4 w-full">
      <span
        className="material-symbols-outlined text-manage-primary text text-end font-extrabold"
        onClick={handleCloseClick}
      >
        close
      </span>
      <div className="my-4">{createAnswerBlock()}</div>
      <form noValidate className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <span className="font-semibold text-manage-primary">組長小叮嚀</span>
        <input
          className="h-12 border border-gray-200 rounded py-3 px-4 placeholder:text-gray-700/70"
          placeholder={t('feedback_modal_placeholder', '寫下您的回饋')}
          value={feedback}
          onChange={handleFeedbackChange}
        />
        <span className={`text-error${!!feedback ? ' hidden' : ''}`}>
          {t('feedback_modal_title', '請填寫要給組員的回饋')}
        </span>
        <button className="bg-manage-sub rounded text-white text-lg py-3">
          {t('save', '儲存', { ns: 'common' })}
        </button>
      </form>
    </div>
  );
}
